import {HttpClient} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CookieSameSite,
  ECookieType,
  ICookie,
  ICookieConsentFormValue,
} from '@app/cookie-consent/models/cookie-consent.model';
import {genCookies} from '@app/cookie-consent/strictly-necessary-cookies/gen.cookies';
import {environment} from '@environments/environment';
import {CookieService} from 'ngx-cookie-service';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CookieManageService {
  private readonly cookieService = inject(CookieService);
  private readonly http = inject(HttpClient);

  private static readonly cookieExpiryTime = environment.cookie.cookieExpirationTimeInDays;

  private _cookieConsentState = new BehaviorSubject<ICookieConsentFormValue | null>(null);
  cookieConsentState$ = this._cookieConsentState.asObservable();

  set cookieConsentState(value: ICookieConsentFormValue | null) {
    this._cookieConsentState.next(value);
  }

  get cookieConsentState(): ICookieConsentFormValue | null {
    return this._cookieConsentState.getValue();
  }

  check(key: string): boolean {
    return this.cookieService.check(key);
  }

  delete(key: string): void {
    this.cookieService.delete(key);
  }

  getStrictlyNecessaryCookies(): ICookie[] {
    return genCookies.filter(cookie => cookie.type === ECookieType.StrictlyNecessary);
  }

  get<T>(key: string): T | null {
    try {
      const serializedValue = this.cookieService.get(key);
      if (serializedValue) {
        return JSON.parse(serializedValue);
      }

      return null;
    } catch (error) {
      console.log(`Can't retrieve cookie with key: ${key}`, error);
      return null;
    }
  }

  set<T>(key: string, value: T): void {
    try {
      const serializedValue = JSON.stringify(value);
      this.cookieService.set(key, serializedValue, {
        expires: CookieManageService.cookieExpiryTime,
        sameSite: environment.cookie.sameSite as CookieSameSite,
      });
    } catch (error) {
      console.log(`Can't set cookie with key: ${key}`, error);
    }
  }
}
